module.exports = __webpack_public_path__ + "img/labelsLikesOrderOn.9d5dad5f.svg";